// extracted by mini-css-extract-plugin
module.exports = {"productTags":"ProductTags_productTags__PTCi2","withIcon":"ProductTags_withIcon__yBqrs"};